import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function Work() {
  const projects = [{
    title: 'ANM №3',
    category: 'Architecture Management',
    description: 'Class-A business center project development within a complex redevelopment',
    image: 'https://storage.yandexcloud.net/maria-images/images/ready_anm/2.jpg',
    color: 'from-emerald-100 to-teal-100',
    link: '/projects/aleksandro-nevsky'
  }, {
    title: 'BioMaxing',
    category: 'Creative Direction, UX/UI',
    description: 'Biohacking multi-platform application spanning Web, Mobile and Telegram',
    image: 'https://storage.yandexcloud.net/maria-images/images/biomaxing_ready/homepage%204%20(1).png',
    color: 'from-cyan-100 to-teal-100',
    link: '/projects/biomaxing'
  }, {
    title: 'ANM Website',
    category: 'UX/UI Design',
    description: 'Website re-design and user experience proposition for Aleksandro-Nevsky Manufacture',
    image: 'https://storage.yandexcloud.net/maria-images/images/anm_web_ready/MacBook%20Pro%2014_%20-%201%20(1).png',
    color: 'from-emerald-100 to-cyan-100',
    link: '/projects/anm-website'
  }, {
    title: 'Co-Lab',
    category: 'Creative Direction, UX/UI',
    description: 'An innovative beauty and wellness-oriented digital marketplace and gamified miniApp',
    image: 'https://storage.yandexcloud.net/maria-images/images/co-lab_ready/Untitled%20design%20(3).png',
    color: 'from-cyan-100 to-stone-100',
    link: '/projects/co-lab'
  }, {
    title: 'Transformer Theatre',
    category: 'Interior Architecture',
    description: 'A renovation proposition for an abandoned Art Deco building in Bournemouth',
    image: 'https://storage.yandexcloud.net/maria-images/images/aub_ready/Generated%20Image%20October%2026,%202025%20-%2011_26AM.png',
    color: 'from-stone-100 to-emerald-100',
    link: '/projects/transformer-theatre'
  }, {
    title: 'Mariinsky Theatre-3',
    category: 'Interior Planning, Cultural Architecture',
    description: "Transforming St. Petersburg's historic Main Post Office into a world-class concert venue",
    image: 'https://storage.yandexcloud.net/maria-images/images/mariinsky_ready/image%20(6).png',
    color: 'from-stone-100 to-teal-100',
    link: '/projects/mariinsky-theatre'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-2523">
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-emerald-500/20 sticky top-0 z-50" data-id="element-2524">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2525">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-emerald-600 transition-colors group" data-id="element-2526">
            <ArrowLeftIcon className="w-5 h-5 group-hover:-translate-x-1 transition-transform" data-id="element-2527" />
            <span className="font-light" data-id="element-2528">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-extralight text-stone-900 tracking-tight" data-id="element-2529">
            Maria Elina
          </h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="relative py-16 px-6 bg-stone-50 overflow-hidden" data-id="element-2530">
        {/* Subtle Green Light Effect */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-2531">
          <div className="absolute top-1/4 right-1/3 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" data-id="element-2532" />
          <div className="absolute bottom-1/4 left-1/3 w-80 h-80 bg-teal-500/10 rounded-full blur-3xl" data-id="element-2533" />
        </div>
        {/* Geometric Accent Elements */}
        <div className="absolute inset-0 pointer-events-none opacity-[0.03]" data-id="element-2534">
          <div className="absolute top-20 right-20 w-96 h-96 border-2 border-emerald-600" style={{
          transform: 'rotate(45deg)'
        }} data-id="element-2535" />
          <div className="absolute bottom-20 left-20 w-80 h-80 border border-emerald-600" style={{
          transform: 'rotate(30deg)'
        }} data-id="element-2536" />
        </div>
        <div className="max-w-7xl mx-auto text-center relative z-10" data-id="element-2537">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-2538">
            <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: 0.8
          }} className="relative h-[2px] w-32 mx-auto mb-12" data-id="element-2539">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-emerald-500 to-transparent" style={{
              clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)'
            }} data-id="element-2540" />
            </motion.div>
            <h2 className="text-6xl md:text-8xl font-extralight text-stone-900 mb-8 tracking-tighter" data-id="element-2541">
              Selected Work
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-2542">
              A collection of projects spanning architecture and creative
              direction
            </p>
            <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="relative h-[2px] w-32 mx-auto mt-12" data-id="element-2543">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-emerald-500 to-transparent" style={{
              clipPath: 'polygon(5% 0, 95% 0, 100% 100%, 0 100%)'
            }} data-id="element-2544" />
            </motion.div>
          </motion.div>
        </div>
        {/* Angular Corner Accents */}
        <div className="absolute top-16 left-0 w-32 h-32 border-t-2 border-l-2 border-emerald-500/20" data-id="element-2545" />
        <div className="absolute top-16 right-0 w-32 h-32 border-t-2 border-r-2 border-emerald-500/20" data-id="element-2546" />
      </section>
      {/* Projects Grid - Even Layout */}
      <section className="relative py-24 px-6 bg-white" data-id="element-2547">
        {/* Diagonal divider */}
        <div className="absolute top-0 left-0 right-0 h-24 bg-stone-50" style={{
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 50%)'
      }} data-id="element-2548" />
        {/* Angular grid */}
        <div className="absolute inset-0 pointer-events-none opacity-[0.02]" data-id="element-2549">
          <div className="absolute inset-0" style={{
          backgroundImage: `
              linear-gradient(30deg, #059669 1px, transparent 1px),
              linear-gradient(-30deg, #059669 1px, transparent 1px)
            `,
          backgroundSize: '120px 120px'
        }} data-id="element-2550" />
        </div>
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-2551">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2552">
            {projects.map((project, index) => <motion.div key={project.title} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group cursor-pointer" data-id="element-2553">
                {project.link ? <Link to={project.link} state={{
              from: '/work'
            }} data-id="element-2554">
                    <div className="relative" data-id="element-2555">
                      {/* Image Container */}
                      <div className="relative overflow-hidden mb-6 aspect-[4/3] bg-stone-200" style={{
                  clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
                }} data-id="element-2556">
                        <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover object-top" whileHover={{
                    scale: 1.05
                  }} transition={{
                    duration: 0.6
                  }} data-id="element-2557" />
                        <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-30 transition-opacity duration-500`} data-id="element-2558" />
                        {/* Angular corner accents */}
                        <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-white/0 group-hover:border-white/60 transition-colors duration-300" data-id="element-2559" />
                        <div className="absolute bottom-4 left-4 w-12 h-12 border-b-2 border-l-2 border-white/0 group-hover:border-white/60 transition-colors duration-300" data-id="element-2560" />
                      </div>
                      {/* Content */}
                      <div className="space-y-3" data-id="element-2561">
                        <p className="text-sm text-emerald-600 font-light tracking-widest uppercase" data-id="element-2562">
                          {project.category}
                        </p>
                        <h3 className="text-3xl font-light text-stone-900 group-hover:text-emerald-600 transition-colors tracking-tight" data-id="element-2563">
                          {project.title}
                        </h3>
                        <p className="text-stone-600 font-light leading-relaxed" data-id="element-2564">
                          {project.description}
                        </p>
                      </div>
                    </div>
                  </Link> : null}
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section id="collaborate" className="relative py-32 px-6 bg-stone-50 overflow-hidden" data-id="element-2565">
        {/* Diagonal divider */}
        <div className="absolute top-0 left-0 right-0 h-24 bg-white" style={{
        clipPath: 'polygon(0 0, 100% 50%, 100% 100%, 0 100%)'
      }} data-id="element-2566" />
        {/* Subtle Green Light Effect */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-2567">
          <div className="absolute top-1/3 left-1/3 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" data-id="element-2568" />
        </div>
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-2569">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-2570">
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.2
          }} className="relative h-[2px] w-32 mx-auto mb-12" data-id="element-2571">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-emerald-500 to-transparent" style={{
              clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)'
            }} data-id="element-2572" />
            </motion.div>
            <h2 className="text-5xl md:text-6xl font-extralight mb-8 text-stone-900 tracking-tight" data-id="element-2573">
              Interested in collaborating?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-12" data-id="element-2574">
              Let's create something meaningful together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-2575">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-2576" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-2577">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-2578" />
                <span className="text-lg font-light relative z-10" data-id="element-2579">
                  Get in Touch
                </span>
              </div>
            </motion.a>
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.8
          }} className="relative h-[2px] w-32 mx-auto mt-12" data-id="element-2580">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-emerald-500 to-transparent" style={{
              clipPath: 'polygon(5% 0, 95% 0, 100% 100%, 0 100%)'
            }} data-id="element-2581" />
            </motion.div>
          </motion.div>
        </div>
        {/* Angular corner accents */}
        <div className="absolute bottom-0 left-0 w-32 h-32 border-b-2 border-l-2 border-emerald-500/30" data-id="element-2582" />
        <div className="absolute bottom-0 right-0 w-32 h-32 border-b-2 border-r-2 border-emerald-500/30" data-id="element-2583" />
      </section>
    </div>;
}